import { render, staticRenderFns } from "./DefTextMenu.vue?vue&type=template&id=0aded057&"
import script from "./DefTextMenu.vue?vue&type=script&lang=js&"
export * from "./DefTextMenu.vue?vue&type=script&lang=js&"
import style0 from "./DefTextMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports